import {Component, OnInit} from '@angular/core';
import { AdminService } from '../../../services/admin.service';
import {AbstractControl, FormControl, FormGroup, Validators} from '@angular/forms';
import {isNumeric} from 'rxjs/internal-compatibility';
import {CustomValidator} from '../../../services/custom-validator';
declare const $;
window['$'] = window['jQuery'] = $;

@Component({
  selector: 'app-ldap',
  templateUrl: './ldap.component.html',
  styleUrls: ['./ldap.component.css']
})
export class LdapComponent implements OnInit {

  ldapForm: FormGroup;
  oldLdapConfiguration: LdapConfiguration;
  testConnectionSucess: boolean;
  previewSearchGroupSucess: boolean;
  previewSearchUserSucess: boolean;
  previewSearchUserProgress: boolean;
  saveConfigurationSucess: boolean;
  saveConfigurationProgress: boolean;
  showMapGroup: boolean;
  showMapUser: boolean;
  showSyncInfo: boolean;
  testConnectionError: string;
  previewSearchGroupError: string;
  testConnectionMessage: string;
  groupSearchEscopeResult;
  groupAttributeNames;
  userAttributeNames;
  userSearchEscopeResult;
  saveConfigurationError: string;
  errorMessage = '';

  get formData() { return this.ldapForm.controls; }

  constructor(private admService: AdminService) {
  }

  ngOnInit() {
    this.testConnectionSucess = false;
    this.previewSearchGroupSucess = false;
    this.previewSearchUserSucess = false;
    this.saveConfigurationProgress = false;
    this.saveConfigurationSucess = false;
    this.previewSearchUserProgress = false;
    this.showMapGroup = false;
    this.showMapUser = false;
    this.showSyncInfo = false;
    this.oldLdapConfiguration = null;
    this.createForm();
    this.onChanges();
    this.getLdapConfiguration();
  }


  createForm() {
    this.ldapForm = new FormGroup({
      server: new FormControl('',Validators.required),
      port: new FormControl('',[CustomValidator.numeric]),
      logon: new FormControl('',Validators.required),
      password: new FormControl('',Validators.required),
      useSsl: new FormControl(false),
      groupBaseDn: new FormControl(''),
      groupSearchFilter: new FormControl(),
      groupSearchEscope: new FormControl(1),
      groupSearchEscopeString: new FormControl("1"),
      groupNameAttrib: new FormControl(''),
      groupDescriptionAttrib: new FormControl(''),
      groupUsersAttrib: new FormControl(''),
      groupProfileAttrib: new FormControl(''),

      userBaseDn: new FormControl(''),
      userDomain: new FormControl(''),
      userSearchAdditionalFilter: new FormControl(''),
      userLogonAttrib: new FormControl(''),
      userProfileAttrib: new FormControl(''),
      userFirstNameAttrib: new FormControl(''),
      userLastNameAttrib: new FormControl(''),
      userEmailAttrib: new FormControl(''),
      crivoUserAttrib: new FormControl(''),

      syncWorkflowUser: new FormControl(''),
      syncWorkflowPassword: new FormControl(''),
      synchronizationInterval: new FormControl(0),

    } as LdapConfigurationControls) as LdapConfigurationFormGroup;
  }

  onChanges(): void {
    this.formData.groupSearchEscopeString.valueChanges.subscribe(x => {
      let stringValue = this.formData.groupSearchEscopeString.value;
      if (isNumeric(stringValue)) {
        this.formData.groupSearchEscope.setValue(Number(stringValue))
      }
    });
  }

  cleanGroupMapValidators(){
    this.ldapForm.get('groupNameAttrib').setValidators(null);
    this.ldapForm.get('groupUsersAttrib').setValidators(null);

    this.ldapForm.get('groupNameAttrib').updateValueAndValidity();
    this.ldapForm.get('groupUsersAttrib').updateValueAndValidity();
  }

  setGroupMapValidators(){
    this.ldapForm.controls.groupNameAttrib.setValidators([Validators.required]);
    this.ldapForm.controls.groupUsersAttrib.setValidators([Validators.required]);

    this.ldapForm.controls.groupNameAttrib.updateValueAndValidity();
    this.ldapForm.controls.groupUsersAttrib.updateValueAndValidity();
  }

  setUserMapValidators(){
    this.ldapForm.controls.userLogonAttrib.setValidators([Validators.required]);
    this.ldapForm.controls.syncWorkflowUser.setValidators([Validators.required]);
    this.ldapForm.controls.syncWorkflowPassword.setValidators([Validators.required]);
    this.ldapForm.controls.synchronizationInterval.setValidators([Validators.required, Validators.min(0)]);

    this.ldapForm.controls.userLogonAttrib.updateValueAndValidity();
    this.ldapForm.controls.syncWorkflowUser.updateValueAndValidity();
    this.ldapForm.controls.syncWorkflowPassword.updateValueAndValidity();
    this.ldapForm.controls.synchronizationInterval.updateValueAndValidity();
  }

  getLdapConfiguration() {
    this.errorMessage = '';
    this.admService.getLdapConfiguration()
      .subscribe(config => {
        if (config && config.server) {
          config.groupSearchEscopeString = config.groupSearchEscope.toString();
          this.ldapForm.setValue(config);
          this.oldLdapConfiguration = Object.assign({}, config) as LdapConfiguration;
          this.testConnectionSucess = true;
          this.onPreviewSearchGroup(true);
        }
      }, error1 => { this.errorMessage = error1; });
  }


  onTestConnection() {
    let ldapConfig = this.ldapForm.value as LdapConfiguration;
    this.testConnectionSucess = false;
    this.testConnectionError = "";
    this.testConnectionMessage = "";


    this.admService.testConnection(ldapConfig)
      .subscribe(resp => {
        if (resp && resp.result && resp.result.indexOf("sucesso") > -1){
          this.testConnectionSucess = true;
          this.testConnectionMessage = resp.result;
          this.showMapGroup = true;
        } else {
          this.testConnectionSucess = false;
          this.testConnectionError = resp.result;
        }
      }, error1 => this.errorMessage = error1);
  }

  onPreviewSearchGroup(loadPreviewSearchUser) {
    let ldapConfig = this.ldapForm.value as LdapConfiguration;

    this.previewSearchGroupSucess = false;
    this.previewSearchGroupError = '';

    this.admService.findGroups(ldapConfig)
      .subscribe(resp => {
        if (resp){
          this.previewSearchGroupSucess = true;
          this.groupSearchEscopeResult = resp;

          this.admService.getGroupAttributeNames(resp)
            .subscribe(attr => {
              if (attr){
                this.groupAttributeNames = attr;
                this.previewSearchGroupSucess = true;
                this.setGroupMapValidators();
                if (loadPreviewSearchUser){
                  this.onPreviewSearchUser();
                } else {
                  this.showMapUser = true;
                  this.showSyncInfo = true;
                }
              } else {
                this.previewSearchGroupSucess = false;
              }
          }, err =>{
            this.previewSearchGroupError = err;
            this.previewSearchGroupSucess = false;
          });
        } else {
          this.previewSearchGroupSucess = false;
        }
      },err =>{
      this.previewSearchGroupError = err;
      this.previewSearchGroupSucess = false;
    });
  }

  onPreviewSearchUser() {
    this.previewSearchUserSucess = false;
    this.previewSearchUserProgress = true;
    let ldapConfig = this.ldapForm.value as LdapConfiguration;

    let entriesByMemberAttribute = this.getEntriesByMemberAttribute(ldapConfig.groupUsersAttrib);
    let userSearchEscopeResult = this.getUsersPreviewByMemberAttribute(entriesByMemberAttribute, ldapConfig.groupUsersAttrib);

    let requestParams = { configuration: ldapConfig, groupEntries: entriesByMemberAttribute };

    this.errorMessage = '';
    this.admService.getUserAttributeNames(requestParams).subscribe(resp => {
      if (resp){
        this.previewSearchUserSucess = true;
        this.userAttributeNames = resp;
        this.userSearchEscopeResult = userSearchEscopeResult;
        this.setUserMapValidators();
      } else {
        this.previewSearchUserSucess = false;
      }
      this.previewSearchUserProgress = false;
    }, error1 => this.errorMessage = error1);
  }

  getEntriesByMemberAttribute = function(groupMemberAttribute){
    var entries = [];
    this.groupSearchEscopeResult.forEach(entry => {
      let entryAttributeDtos = entry.entryAttributeDtos;

      let exists = entryAttributeDtos.some(function (dto, index, _ary) {
        return dto.name == groupMemberAttribute;
      });

      if (exists){
        entries.push(entry);
      }
    });
    return entries;
  };

  getUsersPreviewByMemberAttribute = function (entriesByMemberAttribute, groupMemberAttribute){
    var members = [];
    if (entriesByMemberAttribute){
      entriesByMemberAttribute.forEach(function(entry){

        entry.entryAttributeDtos.forEach(function(dto){
          if (dto.name == groupMemberAttribute && members.indexOf(dto.value) == -1){
            members.push(dto.value);
          }
        });
      });
    }
    return members;
  };

  onSave() {
    let ldapConfig = this.ldapForm.value as LdapConfiguration;
    this.saveConfigurationError = '';

    if (!this.testConnectionSucess){
      var error = {message: 'Para salvar a configuração, é necessário realizar o teste de conexão com sucesso.'}
      return;
    }
    this.saveConfigurationProgress = true;
    this.saveConfigurationSucess = false;

    let requestParams = { configuration: ldapConfig, oldConfiguration: this.oldLdapConfiguration };

    this.admService.saveLdapConfig(requestParams).subscribe(resp => {
      this.saveConfigurationProgress = false;
      this.saveConfigurationSucess = true;
    }, err =>{
      this.saveConfigurationError = err;
      this.saveConfigurationProgress = false;
      this.saveConfigurationSucess = false;
    });
  }


  clearSelectedValue(control: AbstractControl) {
    control.setValue('');
    control.updateValueAndValidity();
  }
}

// Controls in a form group that would emit a LdapConfiguration as it's value
type LdapConfigurationControls = { [key in keyof LdapConfiguration]: AbstractControl };
type LdapConfigurationFormGroup = FormGroup & { value: LdapConfiguration, controls: LdapConfigurationControls };

export class LdapConfiguration {
  server: string;
  port: number;
  logon: string;
  password: string;
  useSsl: boolean ;
  groupBaseDn: string;
  groupSearchFilter: string;

  groupSearchEscope: number;
  groupSearchEscopeString: string;

  groupNameAttrib: string;
  groupDescriptionAttrib: string;
  groupUsersAttrib: string;
  groupProfileAttrib: string;

  userBaseDn: string;
  userDomain: string;
  userSearchAdditionalFilter: string;
  userLogonAttrib: string;
  userProfileAttrib: string;
  userFirstNameAttrib: string;
  userLastNameAttrib: string;
  userEmailAttrib: string;
  crivoUserAttrib: string;

  syncWorkflowUser: string;
  syncWorkflowPassword: string;
  synchronizationInterval: number;

}
